import { render, staticRenderFns } from "./COP3D.vue?vue&type=template&id=540c32e6&scoped=true&"
import script from "./COP3D.vue?vue&type=script&lang=js&"
export * from "./COP3D.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540c32e6",
  null
  
)

export default component.exports